import React from 'react'

import Elo from '@images/elo.png'

export default (props) =>
  <img {...props} src={Elo} style={{ width: '48px', height: '48px' }} />
